import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";

const debug = initDebugger('DokumentOpplastingNyeversjonerDialogKomponent');

/**
 * Dialog som informerer bruker om at det finnes eksisterende versjoner av angitte filer.
 * Gir bruker anledning til å avbryte opplasting.
 */
@Component({
    selector: 'dokument-opplasting-nyeversjoner-dialog',
    templateUrl: 'dokument-opplasting-nyeversjoner-dialog.html',
    styleUrl: 'dokument-opplasting-nyeversjoner-dialog.scss',
    imports: [
        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        TranslateModule,
        MatDialogClose
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DokumentOpplastingNyeversjonerDialogKomponent {

    static vis(dialog: MatDialog, nyeVersjoner: File[]) {
        return dialog.open<DokumentOpplastingNyeversjonerDialogKomponent, DialogParametre, boolean>(DokumentOpplastingNyeversjonerDialogKomponent,
          {
              data: {nyeVersjoner: nyeVersjoner},
              panelClass: 'dokument-opplasting-nyeversjoner-dialog',
              maxWidth: '500px'
          });
    }

    nyeVersjoner: File[];
    
    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre, public dialogRef: MatDialogRef<DokumentOpplastingNyeversjonerDialogKomponent>) {
        this.nyeVersjoner = parametre.nyeVersjoner;
    }
}

export interface DialogParametre {
    nyeVersjoner: File[];
}
